export const BLOOMREACH_SOURCE_FIELDS = [
  { source: "first_name", label: "First name", property: "first_name" },
  { source: "last_name", label: "Last name", property: "last_name" },
  { source: "phone_number", label: "Phone number", property: "phone" },
  { source: "dob", label: "Date of birth", property: "birth_date" },
  { source: "gender", label: "Gender", property: "gender" },
  { source: "age", label: "Age", property: "age_group" },
];

export const DEFAULT_BLOOMREACH_FIELD_MAPPINGS = Object.fromEntries(
  BLOOMREACH_SOURCE_FIELDS.map((field) => [field.source, field.property])
);

export const NONE_BLOOMREACH_PROPERTY = "__none__";

export function normalizeBloomreachFieldMappings(value) {
  const incoming = value && typeof value === "object" ? value : {};
  const normalized = {};
  BLOOMREACH_SOURCE_FIELDS.forEach(({ source }) => {
    if (Object.prototype.hasOwnProperty.call(incoming, source)) {
      normalized[source] = String(incoming[source] || "").trim();
    } else {
      normalized[source] = DEFAULT_BLOOMREACH_FIELD_MAPPINGS[source];
    }
  });
  return normalized;
}

export function toSelectValue(property) {
  return property ? property : NONE_BLOOMREACH_PROPERTY;
}

export function fromSelectValue(value) {
  return value === NONE_BLOOMREACH_PROPERTY ? "" : value;
}
